import { takeLatest } from 'redux-saga/effects';
import {
  getRecognitionWallListSuccess, getRecognitionWallListFail,
  getRecognitionWallDetailsSuccess, getRecognitionWallDetailsFail
} from './recognitionWallState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess 
	} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/recognition-rewards/recognitions-wall');
const redirectData = {route:'/console/recognitions-wall', mode: 'list', recordId:0 };
const modelName = 'Recognition Wall';
const modelId = 'rcw_id';

function* getRecognitionWallList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getRecognitionWallListSuccess, 
		getRecognitionWallListFail,
		null, null, LOADING_MSG);
}

function* getRecognitionWallDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getRecognitionWallDetailsSuccess, 
		getRecognitionWallDetailsFail,
		null, null, LOADING_MSG);		
}

function* doRecognitionWallCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getRecognitionWallDetailsSuccess, 
		getRecognitionWallDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doRecognitionWallUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getRecognitionWallDetailsSuccess, 
		getRecognitionWallDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doRecognitionWallDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getRecognitionWallDetailsSuccess, 
		getRecognitionWallDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* recognitionWallSaga() {
  yield takeLatest('recognitionWall/getRecognitionWallList', getRecognitionWallList);
  yield takeLatest('recognitionWall/getRecognitionWallDetails', getRecognitionWallDetails);
  yield takeLatest('recognitionWall/doRecognitionWallCreate', doRecognitionWallCreate);
  yield takeLatest('recognitionWall/doRecognitionWallUpdate', doRecognitionWallUpdate);
  yield takeLatest('recognitionWall/doRecognitionWallDelete', doRecognitionWallDelete);  
}

export default recognitionWallSaga;
